import { APIConfig } from "../models/api.config";
import BaseService from "./_base.service";

const endpoint = "configs";

const ConfigService = {
  ...BaseService<APIConfig>({ endpoint }),
};

export default ConfigService;
